import { RegionGetResponse as ResGet } from "src/business.InterfaceLayer/store/entities/region.entity/redux/api/types/GET";
import { FromDtoFn } from "src/business.InterfaceLayer/store/types/FromDtoFn.type";
import { convertToServerResponse } from "src/business.InterfaceLayer/store/services/utils.service/convertToServerResponse";
import { REGION_FIELDS } from "../../../redux/fields";
import COMMON_FIELDS from "../../../../../../../general/constants/commonFields";

export namespace RegionFromDtoGet {
	export const regionsFromDto: FromDtoFn<ResGet.RegionGetRegions> = (
		props,
		meta
	) => {
		return props
			? convertToServerResponse(props, meta, {
					[COMMON_FIELDS.COUNT]: props?.count,
					[COMMON_FIELDS.CURRENT_PAGE]: props?.currentPage,
					[COMMON_FIELDS.DATA]: props?.data?.map((e: any) => {
						return {
							[REGION_FIELDS.ID]: e?.id,
							[REGION_FIELDS.HEADER]: e?.header,
						};
					}),
			  })
			: null;
	};
}
